export function viewBoolean(x) {
  if (x === undefined) {
    return '--';
  }
  return x ? 'Yes' : 'No';
}
